import { BoxProps } from "@chakra-ui/react";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import {
  PinComponentLinkedData,
  PinComponentStyle,
} from "interfaces/models/pinComponent";

export interface FieldProps<T = any> {
  value?: T;
  onChange(value?: T): void;
}

export interface FieldRawProps extends BoxProps {
  style: PinComponentStyle;
  item: InspectionItemResult | undefined;
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
  linkedData: PinComponentLinkedData | undefined;
}

export interface NoFieldPreviewProps {
  index: number;
  allItemResultCount: number;
  prevItemResultCount: number;
}

export enum OnChangeType {
  ADD_NEW_IMAGE = "ADD_NEW_IMAGE",
  EDIT_IMAGE = "EDIT_IMAGE",
  CHANGE_IMAGE_FROM_GALLERY = "CHANGE_IMAGE_FROM_GALLERY",
  DELETE_IMAGE = "DELETE_IMAGE",
}

export interface FieldPreviewProps<T = any> extends NoFieldPreviewProps {
  item: InspectionItemResult;
  value?: T;
  isLoading?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isDraggable?: boolean;

  onChange?(
    value?: T | null,
    options?: {
      action: OnChangeType;
    }
  ): Promise<boolean | undefined>;
}

export interface FieldEditorProps<AdditionInfo = any> {
  groupRowIndex: number;
  inspectionResult: InspectionItemResult<AdditionInfo>;
  onChange(value?: any): void;
}

export interface DroppableProps {
  isDragging?: boolean;
}
